const initialValues = {
  title: '',
  level: '',
  company_cust_jobdesc_id: '',
};
export default initialValues;
